var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paneContainer"},[_c('Key'),_c('div',{staticClass:"scroll"},[_vm._t("default")],2),(_vm.studyLocations.length > 0 && _vm.showComparisonBanner)?[_c('ComparisonBanner')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }